<template>
  <div class="flex flex-col sm:flex-row gap-3 mb-6 items-stretch sm:items-center justify-between">
    <!-- Buscador Principal -->
    <div class="relative flex-1">
      <div class="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none text-gray-400">
        <i class="fa fa-search text-sm" />
      </div>
      <input 
        :value="search"
        type="text"
        class="block w-full pl-10 pr-10 py-2.5 bg-white border border-gray-200 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 placeholder-gray-400 transition-all shadow-sm text-sm" 
        placeholder="Buscar por concepto, proveedor o factura..." 
        @input="$emit('update:search', $event.target.value)"
      />
      <button 
        v-if="search" 
        type="button"
        class="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 transition-colors cursor-pointer"
        @click="$emit('update:search', '')"
      >
        <i class="fa fa-times-circle text-sm" />
      </button>
    </div>

    <!-- Filtros Rápidos (Pills) y Estado -->
    <div class="flex flex-wrap items-center gap-2">
      <!-- Pills de Tipo -->
      <div class="flex items-center gap-1.5 overflow-x-auto pb-1 sm:pb-0">
        <button
          type="button"
          class="px-3.5 py-2 rounded-lg text-xs font-semibold whitespace-nowrap transition-colors shadow-xs cursor-pointer"
          :class="tab === 'all' ? 'bg-orange-500 text-white' : 'bg-white text-gray-600 border border-gray-200 hover:bg-gray-50'"
          @click="$emit('update:tab', 'all')"
        >
          Todos
        </button>
        <button
          type="button"
          class="px-3.5 py-2 rounded-lg text-xs font-semibold whitespace-nowrap transition-colors shadow-xs flex items-center gap-1.5 cursor-pointer"
          :class="tab === 'shoppings' ? 'bg-orange-500 text-white' : 'bg-white text-gray-600 border border-gray-200 hover:bg-gray-50'"
          @click="$emit('update:tab', 'shoppings')"
        >
          <i class="fa fa-boxes text-[11px]" />
          Compras
        </button>
        <button
          type="button"
          class="px-3.5 py-2 rounded-lg text-xs font-semibold whitespace-nowrap transition-colors shadow-xs flex items-center gap-1.5 cursor-pointer"
          :class="tab === 'spents' ? 'bg-orange-500 text-white' : 'bg-white text-gray-600 border border-gray-200 hover:bg-gray-50'"
          @click="$emit('update:tab', 'spents')"
        >
          <i class="fa fa-receipt text-[11px]" />
          Gastos
        </button>
      </div>

      <!-- Select de Estado (disponible en 'all' y 'shoppings') -->
      <div v-if="tab !== 'spents'" class="relative w-full sm:w-auto">
        <select 
          :value="status || ''"
          class="w-full sm:w-auto pl-4 pr-10 py-2.5 bg-white border border-gray-200 rounded-lg text-gray-700 text-sm focus:ring-2 focus:ring-orange-500 focus:border-orange-500 shadow-sm cursor-pointer hover:border-gray-300 transition-colors appearance-none font-medium"
          @change="$emit('update:status', $event.target.value ? $event.target.value : null)"
        >
          <option value="">Todos los estados</option>
          <option value="pending">Pendiente</option>
          <option value="paid">Pagada</option>
          <option value="cancelled">Anulada</option>
        </select>
        <div class="absolute inset-y-0 right-0 flex items-center px-2.5 pointer-events-none text-gray-400">
          <i class="fa fa-chevron-down text-xs" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShoppingFilters',

  props: {
    search: {
      type: String,
      default: '',
    },
    tab: {
      type: String,
      default: 'all',
    },
    status: {
      type: [String, null],
      default: null,
    },
  },

  emits: ['update:search', 'update:tab', 'update:status'],
}
</script>
